import React from "react";
import {
  DashboardOutlined,
  SchoolOutlined,
  SectionOutlined,
} from "@toddle-edu/ds-icons";

export const CALENDAR_2_FEATURE_FLAG = "FeatureFlag:EnableAccountCalendar";

export const CALENDAR_SETTINGS_ROUTES = {
  BASE_ROUTE: "calendar-settings",
  EVENT_TYPES: "event-types",
  EVENTS: "events",
  SCHOOL_WISE_INFORMATION: "school-wise-information",
};

export const SIDEBAR_NODE_IDS = {
  EVENT_TYPES: "EVENT_TYPES",
  EVENTS: "EVENTS",
  SCHOOL_WISE_INFORMATION: "SCHOOL_WISE_INFORMATION",
};

export const SIDEBAR_NODE_ID_TO_ROUTE_PATH_MAP = {
  [SIDEBAR_NODE_IDS.EVENT_TYPES]: CALENDAR_SETTINGS_ROUTES.EVENT_TYPES,
  [SIDEBAR_NODE_IDS.EVENTS]: CALENDAR_SETTINGS_ROUTES.EVENTS,
  [SIDEBAR_NODE_IDS.SCHOOL_WISE_INFORMATION]:
    CALENDAR_SETTINGS_ROUTES.SCHOOL_WISE_INFORMATION,
};

/** @typedef {import("@toddle-edu/ds-web").SideNavigationOptionInterface} SideNavOption */
/**
 * @param {(key: string) => string} t
 * @returns {SideNavOption[]}
 */
export const SIDEBAR_OPTIONS = t => [
  {
    key: "root",
    children: [
      SIDEBAR_NODE_IDS.EVENT_TYPES,
      SIDEBAR_NODE_IDS.EVENTS,
      SIDEBAR_NODE_IDS.SCHOOL_WISE_INFORMATION,
    ],
  },
  {
    key: SIDEBAR_NODE_IDS.EVENT_TYPES,
    title: t("calendar:event_types"),
    prefix: <SectionOutlined />,
    parent: "root",
  },
  {
    key: SIDEBAR_NODE_IDS.EVENTS,
    title: t("calendar:events"),
    prefix: <DashboardOutlined />,
    parent: "root",
  },
  {
    key: SIDEBAR_NODE_IDS.SCHOOL_WISE_INFORMATION,
    title: t("calendar:school_wise_information"),
    prefix: <SchoolOutlined />,
    parent: "root",
  },
];
